module.exports = __webpack_public_path__ + "static/banner-image-4-285deae822640513963cabae44b4ba00.jpg";